document.addEventListener("DOMContentLoaded", function () {
    const ukSize = document.getElementById('uk-size');
    const chineseSize = document.getElementById('chinese-size');

    ukSize.onchange = (e) => chineseSize.value = e.target.value
    chineseSize.onchange = (e) => ukSize.value = +e.target.value

    function getChineseSize(ukSize) {
        switch(ukSize) {
            case 0: return 'xxxs';
            case 2: return 'xxs';
            case 4: return 'xs';
            case 6: return 's';
            case 8: return 'm';
            case 10: return 'l';
            case 12: return 'xl';
            case 14: return 'xxl';
            case 16: return 'xxxl'
            case 18: return '4xl';
            case 20: return '5xl';
            case 22: return '6xl';
            default: 'none';
         }
    }
});
